import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';

import { styled } from '@mui/system'; 

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import AddIcon from '@mui/icons-material/Add';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';

import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';


import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  

import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Checkbox from '@mui/material/Checkbox';

import AddVendorsbox from './AddVendors';



let strCust=[{title:'Add Vendor',year:'0',rowindex:'-1'}];



const useStyles = styled(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));


export default class Addvendorpayment extends Component {
 
  constructor(props) {
    super();
	
	 var strdob=new Date();
	 var month="";
	if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}

	
	
	this.state = {veid:'',rowindex:0,
		vendorarrauto:[],vendbilid:'',selectedvendorexchange:[],lefttoalocate:"0.00",
		LedgerData:[],le_id:'',refunddate:Date.now(),
		refunddate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		pmt_paymenttype:'',pmt_reference:'',pmt_amount:'0.00',balance:'0.00',submitbtn:'Save',
		vendorCreditData:[],allchecked:false,vcnid:'',totalamount:0,outstandingamt:0,discount:"0.00",amountpaid:"0.00",
	errortype:"error",totaloutstanding:"0.00",totalpaid:"0.00",totaldiscount:"0.00",
		payingamount:'',baloutstandingamt:'',displaytrue:false,partpayData:[],previocn:'',ind:0,
	btndisabled:false,
	vbstatus:"6",isdispute:false
	
	}
		 this.onTagsVendorexchange = this.onTagsVendorexchange.bind(this);
		  this.insertvendorParent = this.insertvendorParent;
  } 

 insertvendorParent = (childData) => {
	 this.setState({ veid:childData});		  

 }
 
 

updateDonenewParent = (childData) =>{

let strvalues=childData,strind=this.state.ind;
let strarrvalues=strvalues.split('~');

const updatedArrays=[...this.state.vendorCreditData];
	
		  updatedArrays[strind].outstanding = strarrvalues[2] ;
		  updatedArrays[strind].discount = strarrvalues[1] ;
		  updatedArrays[strind].amountpaid = strarrvalues[0];
		
this.CalculateTotal(updatedArrays); 
		  
	  
}
  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    if (nam === "payingamount") {
      let remaining =
        parseFloat(this.state.outstandingamt ) - parseFloat(val);

      this.setState({
        payingamount: val,
        baloutstandingamt: remaining.toFixed(2), 
      });
    }


	else {
      this.setState({ [nam]: val },()=>{
		  
		  if(nam === "vbstatus")
		{
this.vendorCreditGetData(this.state.veid);
		}
		  
	  });
    }
  };


componentWillMount() {

	document.title = "Isifol Account - Vendor Refund";

if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			   this.OnloadLedgerBind();
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		  
	
	
	
}
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=15')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
     this.OnloadLedgerBind();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 


onloadVendorBind=(event)=>{

	 axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=vendorextender&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&ve_contactname='+event.target.value)
  .then(resp => { 
  this.setState({vendorarray:resp.data},()=>{
	  
	   var rowsArray = this.state.vendorarray;
	 rowsArray.map((row, i) => {
			 
		 const items = {
         title:row.title,
         year:row.year,
		 rowindex:row.rowindex,
     balance:row.balance
		
        };
		
		 const cusfound = strCust.some(el => el.year === row.year);
		 if (!cusfound) strCust.push(items)
		  
		 });
	
		  this.setState({vendorarrauto:strCust})
 });
});
	 
	
}


	onTagsVendorexchange = (event, values) => {
	
		this.setState({
		
		veid:values.year,outstandingamt:values.balance,
		selectedvendorexchange:values},()=>{
			
			
			this.vendorCreditGetData(this.state.veid);
		})
		
	
	
       }
 onInputCustChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({vendbilid:newTextValue},()=>{})
	} 
}
	
	
	OnloadLedgerBind(){
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_isbank=1&le_cmp_id='+localStorage.getItem("ISIcmpid"))
	
    
        .then((response) => {    
     
      this.setState({  LedgerData: response.data,  },()=>{
		  
		let maratonFromApi = this.state.LedgerData.map(rep => {
                            
           return {value: rep.le_id, display:rep.le_code+" - "+ rep.le_displayname}
        });
      
        this.setState({
          LedgerData: [{value: '', display: 'Select Ledger'}].concat(maratonFromApi)
        });  
		  
	  });
      })   
   
}
	
	
	
	
Handlerefunddate = (date) => {

    var month="",m="";
	  var date = new Date(date);
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	  
     this.setState({		
		 refunddate:dayjs(date),
refunddate1:date.getFullYear() + '-' + month + '-' +date.getDate(),

	 })
 }
	
	
	
vendorCreditGetData(Vcid){
let strVendor = [];
axios.get(localStorage.getItem("ISIurl")+'ajaxvendorcreditnote.php?action=getall&vcn_vendor='+Vcid+'&vcn_status='+this.state.vbstatus)
     
  .then(resp => {  	
    if(resp.data.length>0){
		resp.data.map((row,i)=>{
			const items = {
				isseleceted:"0",
				creditdate:row.creditdate,
				vcn_vendorcreditnoteno:row.vcn_vendorcreditnoteno,
			    vcn_reference:row.vcn_reference,
				vcnp_total:row.vcnp_total,
				amountdue:row.amountdue,
				outstanding:row.amountdue,
				
				amountpaid:"0",
				vcn_id:row.vcn_id,
				partpayoutstanding:row.amountdue
				
				
			}
			
			
		strVendor.push(items);	
		
	
		});
		
		this.setState({  
			  vendorCreditData:strVendor,
              vcn_id:resp.data[0].vcn_id,		  
			 
			},()=>{
				
				console.log('push data',this.state.vendorCreditData);
				
			});
 this.balamountbind(this.state.veid);
     }
	 
	  else{
		   this.setState({vendorCreditData:[]});
	 }
	 
  
    });
}

balamountbind(Veid){	
    axios.get(localStorage.getItem("ISIurl")+'ajaxvendorbill.php?action=balamtrefundbyvendorid&vb_vendor=' + Veid)
    .then(resp => {  	
        if (resp.data !== null && resp.data !== undefined) {
            this.setState({  
                invoiceamtData: resp.data, 
                baloutstandingamt: parseFloat(resp.data).toFixed(2)
            });
        } else {
            this.setState({invoiceamtData: [], baloutstandingamt: 0.00});
        }
    })
 
}


onClickSalesSave= (event) => {
	
let optionsVal=this.state.vendorCreditData;



	 if(this.state.veid === "")
	 {		 
		 this.setState({errormessage:"Please Select Vendor",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	



	 if(this.state.le_id === "")
	 {		 
		 this.setState({errormessage:"Please Select Ledeger",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	


 if(this.state.pmt_paymenttype === "")
	 {		 
		 this.setState({errormessage:"Please Select Payment Type",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	

if(this.state. refunddate=== "")
	 {		 
		 this.setState({errormessage:"Please Select Payment Date",erropen:true,errortype:"error"});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	

 if (this.state.pmt_amount === "" || this.state.pmt_amount === "0.00" ) {
        this.setState({ errormessage: "Please Select Outstanding Bills", erropen: true, });
        window.scrollTo({ top: 0 })
        return false;
    }


	this.setState({btndisabled:true,submitbtn:"Processing..."})


	 
var formData = new FormData();
formData.append('action','Bulkinsert')

formData.append('pmt_amount',this.state.pmt_amount) 			
formData.append('pmt_paymentdate',this.state.refunddate1) 			
formData.append('pmt_ledger_id',this.state.le_id) 			
formData.append('pmt_paymenttype',this.state.pmt_paymenttype) 			
formData.append('pmt_reference',this.state.pmt_reference) 			
formData.append('pmt_type',8) 

let sep1="",optionValues="";


	  optionsVal.forEach(eachval => {
		  
	   if(eachval.isseleceted==="1")
	   {
		   
 optionValues=optionValues+sep1+eachval.amountpaid+"~"+eachval.vcn_id+"~0~4";
 sep1="`"; 
	   }
		else{
			
			
		
		}
		   
	 
    })	
formData.append('reciept',optionValues) 	
formData.append('pmt_cmp_id',localStorage.getItem("ISIcmpid"))
 formData.append('userid',localStorage.getItem("ISIuserid"))			
	formData.append('pmt_cu_id',this.state.veid) 

			 axios.post(localStorage.getItem("ISIurl")+"ajaxpayments.php", formData, {
        })	
.then(res => {
				
	this.setState({vendorCreditData:[],baloutstandingamt:0,pmt_amount:'',pmt_reference:'',le_id:'',btndisabled:false,pmt_paymenttype:'',
	submitbtn:'save',errormessage:'Payment Submitted Successfully',errortype:'success',erropen:true,selectedvendorexchange:[],outstandingamt:0,
				
	});
			
});
	
	
	
}


 HandleAllcheckbox=()=>{
	
	  var studArray = this.state.vendorCreditData;
	  const updatedArray = [...this.state.vendorCreditData];
	  this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
			
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isseleceted = "0" ;
					 
					  updatedArray[j].amountpaid = "0.00";
    updatedArray[j].outstanding = updatedArray[j].amountdue;
					 
					 this.CalculateTotal(studArray);
				 });
		 }
		 else if(this.state.allchecked===true)
		 {
				
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
				   
				   updatedArray[j].amountpaid = updatedArray[j].amountdue;
				   updatedArray[j].outstanding = "0.00";
				   
				   this.CalculateTotal(studArray);
				   
				   
				   
		    });
				 
	     }
			 
			this.setState({vendorCreditData:updatedArray,},()=>{
				
	
			});
		 
	 }); 
	
	 
} 
   
HandleCheckbox = (id, rowsd) => {
  const updatedArray = [...this.state.vendorCreditData];

  if (updatedArray[rowsd].isseleceted === "0") {
    updatedArray[rowsd].isseleceted = "1";
    updatedArray[rowsd].amountpaid = updatedArray[rowsd].amountdue;
    updatedArray[rowsd].outstanding = "0.00";
  } else {
    updatedArray[rowsd].isseleceted = "0";
    updatedArray[rowsd].amountpaid = "0.00";
    updatedArray[rowsd].outstanding = updatedArray[rowsd].amountdue;
  }
 
this.CalculateTotal(updatedArray);
};


 
CalculateTotal(array){
	
  this.setState({vendorCreditData:array}, () => {
    const optionsVal = this.state.vendorCreditData;
    let Totalamount = 0;

    optionsVal.forEach(eachval => {
      if (eachval.isseleceted === "1") {
        Totalamount += parseFloat(eachval.amountpaid);
		
      }
    });
	

    this.setState({ pmt_amount:Totalamount.toFixed(2) });
	  });
	
}
 

 
Oncloseicon = () => {
    this.setState({ open: !this.state.open });
  };

handleClose=()=>{
	
	 this.setState({ open: !this.state.open });
};


handleVendorInsertpopup= (e) => {
	  this.setState({ veid: 0 },()=>{this.refs.AddVendorsbox.handlevendorClickOpen()});  
	
}
  
	 handledraft=(e)=>{
	this.setState({isdispute: !this.state.isdispute},()=>{
		
		
	}); 
 }
  
  render() { 


let	granddiscount=0;
let grandtotal=0;
let grandpaid=0;let outstandingamt=0;


	  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


return (
  <React.Fragment> 
    <div className="contenttext">

      <p>
        <Collapse in={this.state.erropen}>
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.handleErrorclose();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            } 
            severity={this.state.errortype}
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>
      </p>
      
      <ul >
        <li>
          <p><span className="validation">*</span>Vendor</p>
          <p>
            <Autocomplete
              id="free-solo-demo"
              className="txtbox" 
              inputValue={this.state.vendbilid}
              options={this.state.vendorarrauto}   
              onInputChange={this.onInputCustChange}
              onChange={this.onTagsVendorexchange} 
              value={this.state.selectedvendorexchange}
              renderInput={(params) => ( 
                <TextField  
                  placeholder="Search for a vendor" 
                  {...params} 
                  className="txtbox" 
                  onChange={this.onloadVendorBind}  
                  variant="outlined" 
                />
              )}
              getOptionLabel={(option) => option.title || ""}
              renderOption={(props, option) => (
                <React.Fragment>
                  <table width='200%'>
                    <tbody> 
                      {option.rowindex !== "-1" && (
                        <tr {...props}>
                          <td width='10%'>{option.title}</td>
                        </tr>
                      )}
                      {option.rowindex === "-1" && (
                        <tr {...props}>
                          <td width='10%' onClick={this.handleVendorInsertpopup}>
                            <span className='addautoextender'>
                              <AddIcon />
                              {option.title}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </React.Fragment>
              )}
            />
          </p>
          <AddVendorsbox ref="AddVendorsbox" id={0} updatevendor={this.insertvendorParent}/>
			  { /* {this.state.outstandingamt !== 0 && (
            <p>You owe this supplier ${this.state.outstandingamt}</p>
			  )}*/}
        </li>
        
        <li>
          <p><span className="validation">*</span>Paid into Bank Account</p>
          <p>
            <FormControl className="stadrp">
              <Select
                native 
                fullWidth
                variant="outlined"
                margin="normal"
                defaultValue={{ value: this.state.le_id }}
                onChange={this.myChangeHandler}
                id="le_id"
                value={this.state.le_id} 
                className="txtbox"
                name="le_id"
                inputProps={{ tabIndex: "1" }}
              >
                {this.state.LedgerData.map(age => (
                  <option value={age.value}>{age.display}</option>
                ))}
              </Select>
            </FormControl>
          </p>
          <p>	


{this.state.veid !== "" && (
  <p className="custtext">
    You owe this supplier $
    {this.state.baloutstandingamt === null || this.state.baloutstandingamt === undefined || this.state.baloutstandingamt === ""
      ? '0.00'
      : this.state.baloutstandingamt
    }
	
  </p>
)}
	  </p>
        </li>
        
        <li>
          <p><span className="validation">*</span>Method</p>
          <p>
            <FormControl className="stadrp">
              <Select
                native
                variant="outlined"
                margin="normal"
                onChange={this.myChangeHandler} 
                className="txtbox"
                id="pmt_paymenttype"
                value={this.state.pmt_paymenttype}
                name="pmt_paymenttype"
                inputProps={{ tabIndex: "6" }}
              >
                <option value="">Select </option>
                <option value={1}>Cash</option>
                <option value={2}>Check</option>
                <option value={3}>Electronic</option>
                <option value={4}>Credit/Debit Card</option>
                <option value={5}>Paypal</option>
              </Select>
            </FormControl>
          </p>
        </li>
        
        <li>
          <p><span className="validation">*</span>Date Refunded</p>
          <p>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']}>
                <DatePicker
                  value={dayjs(this.state.refunddate)}
                  className="txtbox"
                  Name="refunddate"
                  onChange={this.Handlerefunddate} 
                  format="MM/DD/YYYY"
                />
              </DemoContainer>
            </LocalizationProvider>
          </p>
        </li>
        
        <li>
          <p>Your Reference (optional)</p>
          <p>
            <TextField 
              variant="outlined"
              margin="normal"
              fullWidth
              value={this.state.pmt_reference}
              id="pmt_reference"
              className="txtbox"
              name="pmt_reference" 
              onChange={this.myChangeHandler}
              placeholder="eg Check Number"
            />
          </p>
        </li>
        
        <li>
          <p><span className="validation">*</span>Amount Refunded</p>
          <p>
            <TextField 
              variant="outlined"
              margin="normal"
              fullWidth
              value={this.state.pmt_amount}
              id="pmt_amount"
              className="txtbox"
              name="pmt_amount" 
              onChange={this.myChangeHandler}
              placeholder=""
            />
          </p>
        </li>
      </ul>

	</div>
	

    <div className="ordtbl">
	
	
	<div className="filterright">
<ul>
<li>Display: <Select
 native
 variant="outlined" className="txtbox"
 margin="normal"
  
 onChange={this.myChangeHandler}
  id="role"
 value={this.state.vbstatus}
 name="vbstatus"
 inputProps={{tabIndex: "4"}}
    >
<option value={6}>Outstanding</option>
<option value={" "}>All</option>
<option value={2}>Due</option>	

	
</Select>
</li>


</ul>
</div>
	<div className="clear"></div>
	
      <Paper className={useStyles.root}>
        <TableContainer className={useStyles.container}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell width="5%">
                  <Checkbox 
                    checked={this.state.allchecked}
                    onChange={() => { this.HandleAllcheckbox() }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    sx={{
                      color: 'white',
                      '&.Mui-checked': { color: 'white' },
                    }}
                  />
                </TableCell>
                <TableCell width="5%"><b>Date</b></TableCell>
                <TableCell width="5%"><b>Number</b></TableCell>
                <TableCell width="5%"><b>Reference</b></TableCell>
                <TableCell width="5%"><b>Type</b></TableCell>
                <TableCell width="5%"><b>Total</b></TableCell>
                <TableCell width="5%"><b>Outstanding</b></TableCell>
    
                <TableCell width="5%"><b>Paid</b></TableCell>
              </TableRow>
            </TableHead>
            
            <TableBody>
             
			  {this.state.vendorCreditData.length>0 && (	<React.Fragment>		
			  {(this.state.vendorCreditData).map((item,index) => {

if(item.outstanding===null || item.amountpaid===null)
{
	item.outstanding=0.00;
	item.amountpaid=0.00;
	
}
else{
	item.outstanding=item.outstanding
	item.amountpaid=item.amountpaid;
	
}

outstandingamt=parseFloat(outstandingamt)+parseFloat(item.outstanding)
granddiscount=(parseFloat(granddiscount)+parseFloat(item.discount)).toFixed(2) 
grandtotal=parseFloat(item.amountpaid) +parseFloat(grandtotal)     

				
           return ( <React.Fragment>
 
 <TableRow key={index} >

  <TableCell>
                    {item.isseleceted === "0" && (
                      <Checkbox
                        onChange={() => { this.HandleCheckbox(item.vcn_id, index) }}
                        inputProps={{ 'aria-label': 'controlled' }}
                        sx={{ '&.Mui-checked': { color: 'gray' } }}
                      />
                    )}
                    {item.isseleceted === "1" && (
                      <Checkbox
                        checked
                        onChange={() => { this.HandleCheckbox(item.vcn_id, index) }}
                        sx={{ '&.Mui-checked': { color: 'gray' } }}
                      />
                    )}
                  </TableCell>

 <TableCell>{item.creditdate}</TableCell>
                  <TableCell>{item.vcn_vendorcreditnoteno}</TableCell>
                  <TableCell>{item.vcn_reference}</TableCell>
                  <TableCell>CRN</TableCell>
                  <TableCell>-{item.vcnp_total}</TableCell>
				  
				  <TableCell>{item.outstanding === null || item.outstanding === "" ? 0 : "-"+item.outstanding}</TableCell>

<TableCell>



{item.amountpaid}
</TableCell>


 </TableRow>

				</React.Fragment>	
				);
					})}	
			  
			 
			  
<TableRow  >
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell colspan={1} align="right">

<TextField name="grandtotal" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={parseFloat(outstandingamt).toFixed(2)}
			 
			
			  inputProps={{tabIndex: "1",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>

						  <TableCell colspan={1} align="right"><TextField name="grandpaid" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={parseFloat(grandtotal).toFixed(2)}
			 
			
			  inputProps={{tabIndex: "3",maxLength:5}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>

</TableRow>					  
			  
			</React.Fragment>  
			  )}

  {this.state.vendorCreditData.length===0 && (

<TableRow>
<TableCell colspan="8" align="center"></TableCell></TableRow>
 )}
  
<TableRow>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>
<TableCell></TableCell>

<TableCell></TableCell>	
<TableCell>Left to allocate </TableCell>	
 <TableCell colspan={1} align="right"><TextField name="lefttoalocate" 
	   onChange={this.myChangeHandler} 
	   fullWidth disabled
	   value={this.state.lefttoalocate}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></TableCell>
</TableRow>			
			  
			  
			  
			  
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>  
    </div>
    
	
	
   <br/>
  <div className="salesactions">
   <p>
		
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>

   </div>
  
   <div className="clear"></div>
	  
	  
   
  </React.Fragment>
);
  }
}

